// Map initiative codes to program names
export const PROGRAM_MAPPING = {
  'SP01': 'SP01 - Breeding for Tomorrow',
  'SP02': 'SP02 - Sustainable Farming',
  'SP03': 'SP03 - Sustainable Animal and Aquatic Foods',
  'SP04': 'SP04 - Multifunctional Landscapes',
  'SP05': 'SP05 - Better Diets and Nutrition',
  'SP06': 'SP06 - Climate Action',
  'SP07': 'SP07 - Policy Innovations',
  'SP08': 'SP08 - Food Frontiers and Security',
  'SP09': 'SP09 - Scaling for Impact',
  'SP10': 'SP10 - Gender Equality and Inclusion',
  'SP11': 'SP11 - Capacity Sharing',
  'SP12': 'SP12 - Digital Transformation',
  'SP13': 'SP13 - Genebank',
  // Legacy initiative codes (for backward compatibility)
  'INIT-01': 'SP01 - Breeding for Tomorrow',
  'INIT-02': 'SP02 - Sustainable Farming',
  'INIT-03': 'SP03 - Sustainable Animal and Aquatic Foods',
  'INIT-05': 'SP05 - Better Diets and Nutrition',
  'INIT-06': 'SP06 - Climate Action',
  'INIT-11': 'SP11 - Capacity Sharing',
  'INIT-12': 'SP12 - Digital Transformation',
  'INIT-13': 'SP13 - Genebank',
  'INIT-17': 'SP03 - Sustainable Animal and Aquatic Foods',
  'INIT-20': 'SP04 - Multifunctional Landscapes',
  'INIT-22': 'SP01 - Breeding for Tomorrow',
  'INIT-24': 'SP07 - Policy Innovations',
  'INIT-27': 'SP09 - Scaling for Impact',
  'SGP-01': 'SGP - Science Group Projects',
};

// Map result Type → Level (Output / Outcome / Impact)
// The consolidated Excel has no explicit Level column — derive from Type.
export const TYPE_TO_LEVEL = {
  'Knowledge product': 'Output',
  'Innovation development': 'Output',
  'Other output': 'Output',
  'Capacity sharing for development': 'Output',
  'Innovation use': 'Outcome',
  'Policy change': 'Outcome',
  'Other outcome': 'Outcome',
  'Innovation Package': 'Outcome',
  'Capacity change': 'Outcome',
  'Complementary innovation': 'Outcome',
  'Impact contribution': 'Impact',
};

// Type mapping for result types
export const RESULT_TYPE_COLORS = {
  'Knowledge product': '#3b82f6',
  'Innovation development': '#8b5cf6',
  'Innovation use': '#22c55e',
  'Capacity sharing for development': '#f59e0b',
  'Policy change': '#ef4444',
  'Other output': '#6b7280',
  'Other outcome': '#06b6d4',
  'Innovation Package': '#ec4899',
  'Capacity change': '#14b8a6',
  'Impact contribution': '#f97316',
  'Complementary innovation': '#a855f7',
};

// Score for results with no impact area data provided
export const NOT_PROVIDED_SCORE = -1;

// Impact area score mapping
export const IMPACT_SCORES = {
  '(0) Not Targeted': 0,
  '(1) Significant': 1,
  '(2) Principal': 2,
  'Not Targeted': 0,
  'Significant': 1,
  'Principal': 2,
};
